<template>
    <el-container style="height:100%;">
        <el-header>
            <el-row type="flex" style="align-items:center;">
                <el-col :span="12" style="display:flex;align-items:center;">
                    <img height="50" src="@/assets/logo_mete.png" style="margin-left: 15px;">
                    <h1 class="title" style="margin-left:2%;">米特外送運能整合</h1>
                </el-col>
                <el-col :offset="6" :span="3" style="height:35px;display:flex;align-items:center;border:2px solid #BBE2F2;border-radius: 13px;padding:5px;">
                    <img src="../assets/icons_wallet.png" style="width:25px; margin-right: 12px;">
                    <span class="header-span" style="font-weight: bold;line-height:35px;">NTD${{balAmt}}</span>
                </el-col>
                <el-col :span="3" style="display:flex;align-items:center;">
                    <img src="../assets/icons_member.png" style="width: 35px; margin: 0 12px;">
                    <span class="header-span">{{USER_NAME}}</span>
                </el-col>
            </el-row>
        </el-header>
        <el-container>
            <el-aside style="width: auto; height: 100%; background-color: #BBE2F2 ">
                <SideBar ref="SideBar"></SideBar>
                <div style="width: 160px; bottom: 0; position: absolute; left: 20px; margin-bottom: 50px;">
                    <el-row style="justify-content: center;">
                        <el-button id="btn_logout" v-on:click="onLogout">登出</el-button>
                    </el-row>
                </div>
            </el-aside>
            <el-container class="tabs">
                <el-main style="background-color: #BBE2F2;">
                    <div class="mainBlock">
                        <template v-if="options.length==0">
                            <router-view name="HomePage"></router-view>
                        </template>
                        <template v-else>
                            <el-tabs v-model="activeIndex"
                                     type="card"
                                     @tab-remove="tabRemove"
                                     v-show="options.length>0"
                                     closable>
                                <el-tab-pane :key="item.num"
                                             v-for="(item) in options"
                                             :p_id="item.num"
                                             :label="item.name"
                                             :name="item.route" class="tab-pane">
                                    <router-view v-show="options.length>0" :name="item.route.replace('/','')" />
                                </el-tab-pane>
                            </el-tabs>
                        </template>
                    </div>
                </el-main>
            </el-container>
            <el-backtop :right="10" :bottom="10" />
        </el-container>
    </el-container>
</template>

<script>
    import SideBar from "@/components/SideBar.vue";
    import $api from '@/utils/axios';
    import { ElMessage, ElMessageBox } from 'element-plus';
    export default {
        components: {
            SideBar
        },
        data() {
            return {
                COMP_NAME: localStorage.getItem("VendorId"),
                USER_NAME: localStorage.getItem("UserName"),
                //BAL_AMT: localStorage.getItem("BalAmt")
            }
        },
        methods: {
            tabRemove(targetName) {
                this.$store.commit('delete_tabs', targetName);
                if (this.activeIndex === targetName) {
                    // 設置當前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length - 1].route);
                        //this.$router.push({ path: this.activeIndex });
                    } else {
                        //this.$router.push({ path: '/Home' });
                    }
                }
            },
            onLogout() {
                localStorage.clear();
                this.$store.commit('clear_all_tabs');//重製頁簽
                this.$router.push('/');
            }
        },
        computed: {
            options() {
                return this.$store.state.options;
            },
            activeIndex: {
                get() {
                    return this.$store.state.activeIndex;
                },
                set(val) {
                    this.$store.commit('set_active_index', val);
                }
            },
            balAmt() {
                return this.$store.state.balAmt;
            }
        },
        watch: {
            '$route'(to) {
                let flag = false;
                for (let option of this.options) {
                    if (option.name === to.name) {
                        flag = true;
                        this.$store.commit('set_active_index', '/' + to.path.split('/')[1]);
                        break
                    }
                }
            }
        },
        mounted: function () {
            if (!localStorage.getItem('UserName')) {
                this.$router.push('/');
            }
            if (this.$route.query.retflag == "Y") {
                this.$refs.SideBar.handleSelect("/MyData|我的資料","");
            }
            //重整網頁時更新儲值餘額
            this.$store.dispatch('getBalAmt');
        },

    }
</script>

<style>
    .tab-pane {
        border: 1px solid var(--el-border-color-light);
        border-top: 0;
    }

    .header-span {
        font-size: 12pt;
    }

    .el-dropdown {
        color: white;
    }

    .mainBlock {
        height: calc(100vh - 160px);
        padding: 20px;
        background-color: #FFFFFF;
        border-radius: 30px;
    }

    #btn_logout {
        width: 100%;
        height: 35px;
        color: #353839;
        border: 2px solid white;
        border-radius: 13px;
        background: transparent;
    }

        #btn_logout:hover {
            color: #00B8DE;
            background: #FFFFFF;
        }
</style>
